import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { tooltipAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: tooltipAnatomy.keys(),

  base: {
    content: {
      wordBreak: "break-word",
    },
  },
});
